// Asks the admin to confirm a product is complete and ready to be sold
// before submitting a status change to "unlisted" — unlisted products are
// hidden from the marketplace but stay live and purchasable by direct URL.
$(document).on("turbolinks:load", function () {
  $("form[data-unlist-confirm]").on("submit", function () {
    var $form = $(this)
    var selected = $form.find("select[name='product[status]']").val()

    if (selected !== "unlisted" || $form.data("current-status") === "unlisted")
      return

    var message =
      "Unlist this product?\n\n" +
      "It will be hidden from the marketplace but remain live and purchasable at its direct URL.\n\n" +
      "Please confirm the product is complete and ready to be sold."

    var remaining = $form.data("completeness-remaining")
    if (remaining > 0) {
      message +=
        "\n\nWarning: " +
        remaining +
        " required completeness item(s) are unfinished."
    }

    return confirm(message)
  })
})
